/**
 * @generated SignedSource<<72c92d66f3a0daf43b809461d248fa18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EmailRegenerateCodeMutationInput = {
  clientMutationId?: string | null;
};
export type EmailEditConfirmCResendMutation$variables = {
  input: EmailRegenerateCodeMutationInput;
};
export type EmailEditConfirmCResendMutation$data = {
  readonly emailRegenerateCode: {
    readonly __typename: "EmailRegenerateCodeError";
    readonly message: string;
  } | {
    readonly __typename: "EmailRegenerateCodeToken";
    readonly token: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type EmailEditConfirmCResendMutation = {
  response: EmailEditConfirmCResendMutation$data;
  variables: EmailEditConfirmCResendMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "emailRegenerateCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "token",
            "storageKey": null
          }
        ],
        "type": "EmailRegenerateCodeToken",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "type": "EmailRegenerateCodeError",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailEditConfirmCResendMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailEditConfirmCResendMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "afa07fbda127b43f260dd98971abb5e3",
    "id": null,
    "metadata": {},
    "name": "EmailEditConfirmCResendMutation",
    "operationKind": "mutation",
    "text": "mutation EmailEditConfirmCResendMutation(\n  $input: EmailRegenerateCodeMutationInput!\n) {\n  emailRegenerateCode(input: $input) {\n    __typename\n    ... on EmailRegenerateCodeToken {\n      token\n    }\n    ... on EmailRegenerateCodeError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "806b54a4570673a3f6edab360ae485d8";

export default node;
